<template>
  <div>
    <h6 class="font-weight-bold">فعال سازی اشتراک برای کاربر : </h6>
    <v-select v-model="selectedPlan"
               dir="rtl"
              :options="plans" placeholder="اشتراک مورد نظر خود را انتخاب کنید">
      <template v-slot:option="option">
        <span :style="{color : option.color}" class="font-weight-bold">
        <strong>{{ option.title }}</strong> {{option.type === 'seller'?'(فروشنده)':'(خریدار)'}}
        </span>
      </template>
      <template #selected-option="{ title, type ,color}">
        <div :style="{color : color}">
          <strong>{{ title }}</strong>&nbsp;{{type === 'seller'?'(فروشنده)':'(خریدار)'}}
        </div>
      </template>
    </v-select>
    <div v-if="selectedPlan">
      <div class="row mt-2">
        <div class="col-12 col-md-3 mb-2">عنوان : {{ selectedPlan.title }}</div>
        <div class="col-12 col-md-3 mb-2">مربوط به :
          {{ (selectedPlan.type === 'seller' ? 'فروشنده' : 'خریدار') }}
        </div>
        <div class="col-12 col-md-3 mb-2">
          اشتراک آغازین :
          <span v-if="selectedPlan.is_starter" class="text-success">می باشد</span>
          <span v-else class="text-danger">نمی باشد</span>
        </div>
        <div class="col-12 col-md-3 mb-2">
          توضیحات :
          {{ selectedPlan.description }}
        </div>
      </div>
      <div class="font-weight-bold mt-2">انتخاب بازه زمانی</div>
      <div class="table-responsive mt-2">
        <table class="table">
          <tr @click="price_id = item.id" :class="'table-tr '+(price_id === item.id?'active_tr':'')" v-for="(item,index) in selectedPlan.prices" :key="item">
            <td>
              {{item.title}}
            </td>
            <td>
              تعداد سکه :
              {{item.n_coin}}
            </td>
            <td>
              تعداد روز :
              {{item.n_day}}
            </td>
            <td>
              قیمت :
              {{item.price}}
            </td>
          </tr>
        </table>
      </div>
      <div class="row">
        <div class="col-10 col-sm-7 col-md-4 mx-auto my-2">
          <button @click="activePlan" class="btn btn-primary btn-block">فعال سازی</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import vSelect from 'vue-select'
import {showSystemNoti} from "@/shared/helper";
import {AppApi} from "@/api/AppApi";
export default {
  name: "activePlanUser",
  components: {vSelect},
  props:['plans','user_id'],
  data()
  {
    return{
      selectedPlan : null,
      price_id : null
    }
  },
  methods:{
    async activePlan()
    {
      const selectedPlan = this.selectedPlan;
      const price_id = this.price_id;
      if (!selectedPlan)
        return showSystemNoti('danger','اشتراک را انتخاب کنید');
      if (!price_id)
        return showSystemNoti('danger','بازه زمانی را انتخاب کنید.');
      const self = this;
      Swal.fire({
        title: '<strong>آیا اطمینان دارید؟</strong>',
        icon: 'info',
        html: 'اشتراک انتخاب شده برای کاربر فعال خواهد شد.',
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
            '<i class="fa fa-thumbs-up"></i> تایید!',
        cancelButtonText:
            '<i class="fa fa-thumbs-down"></i>',
      }).then( async (result)=> {
        if (result.value)
        {
          const data = {plan_id : selectedPlan._id,price_id,user_id : self.user_id}
          const result = await AppApi.ActivePlanForUser(data);
          if (result.ok)
          {
            showSystemNoti('success',result.message);
            self.$emit('successCallback',true)
          }
          else
            showSystemNoti('danger',result.error);
        }
    })
    }
  },
  watch:{
    selectedPlan:{
      handler(h)
      {
        if (h)
          this.price_id = null;
      }
    }
  }
}
</script>

<style scoped>
.active_tr
{
  background: cornflowerblue;
}
.table-tr
{
  cursor: pointer;
}
</style>